import { createContext, useContext } from 'react';

import type { AnalyticsOperator, AnalyticsSession } from '@/lib/authService';

export type AuthStatus = AnalyticsSession['status'] | 'error' | 'loading' | 'newPasswordRequired';

export type AnalyticsAuthState = {
  error: string | null;
  completeNewPassword: (password: string) => Promise<void>;
  login: (email: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
  operator: AnalyticsOperator | null;
  reload: () => Promise<void>;
  status: AuthStatus;
};

export const AnalyticsAuthContext = createContext<AnalyticsAuthState | null>(null);

export const useAnalyticsAuth = (): AnalyticsAuthState => {
  const value = useContext(AnalyticsAuthContext);
  if (!value) {
    throw new Error('useAnalyticsAuth must be used inside AnalyticsAuthProvider');
  }
  return value;
};
